import React from "react";

// Styles
// import Style from "./NotFoundView.module.css";

const NotFoundView = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <h2>404</h2>
      <p>Page not found</p>
    </div>
  );
};

export default NotFoundView;
